module.exports = __webpack_public_path__ + "static/media/west.c4f3d1a3.jpg";